enum AuthenticationGuideCheckStatus {
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
}

export default AuthenticationGuideCheckStatus;
